import React from 'react';
import { FaCheckCircle, FaAward, FaUsers, FaRocket } from 'react-icons/fa';

const About: React.FC = () => {
  const features = [
    'Microsoft Silver Certified Partner',
    'Expert IT Consultants',
    'Custom Software Solutions',
    'Cloud Infrastructure Specialists',
    '24/7 Technical Support',
    'Cost-Effective Solutions',
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content - Image/Visual */}
          <div className="relative">
            <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-2xl p-8 md:p-12">
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-white bg-opacity-20 backdrop-blur rounded-xl p-6 text-white text-center">
                  <FaAward className="text-4xl mx-auto mb-3 text-orange-400" />
                  <h4 className="text-3xl font-bold">7+</h4>
                  <p className="text-sm">Years of Excellence</p>
                </div>
                <div className="bg-white bg-opacity-20 backdrop-blur rounded-xl p-6 text-white text-center">
                  <FaUsers className="text-4xl mx-auto mb-3 text-orange-400" />
                  <h4 className="text-3xl font-bold">500+</h4>
                  <p className="text-sm">Happy Clients</p>
                </div>
                <div className="bg-white bg-opacity-20 backdrop-blur rounded-xl p-6 text-white text-center">
                  <FaRocket className="text-4xl mx-auto mb-3 text-orange-400" />
                  <h4 className="text-3xl font-bold">100+</h4>
                  <p className="text-sm">Projects Delivered</p>
                </div>
                <div className="bg-white bg-opacity-20 backdrop-blur rounded-xl p-6 text-white text-center">
                  <FaCheckCircle className="text-4xl mx-auto mb-3 text-orange-400" />
                  <h4 className="text-3xl font-bold">99%</h4>
                  <p className="text-sm">Client Satisfaction</p>
                </div>
              </div>
            </div>
            {/* Decorative Elements */}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-orange-500 rounded-full opacity-20"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-blue-500 rounded-full opacity-20"></div>
          </div>

          {/* Right Content - Text */}
          <div className="space-y-6">
            <span className="text-blue-600 font-semibold text-lg">About Us</span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800">
              Your Trusted IT Partner Since 2017
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed">
              Astrix Infonet is a complete IT solutions provider based in Greater Noida, India.
              We are committed to providing comprehensive and effective information technology
              services to businesses across various industries.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed">
              As a Microsoft Silver Certified Partner, we help make our clients' businesses
              more efficient through a combination of process transformation, outsourcing,
              and expert consulting. Our team of skilled professionals is dedicated to
              delivering innovative solutions that drive growth and success.
            </p>

            {/* Features List */}
            <div className="grid grid-cols-2 gap-4 pt-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center">
                  <FaCheckCircle className="text-green-500 mr-3 flex-shrink-0" />
                  <span className="text-gray-700">{feature}</span>
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <div className="pt-6">
              <a
                href="#contact"
                className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105"
              >
                Learn More About Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
